import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StatusCode } from '../../components/Alert.tsx';
import MeasurementUnitsController from '../../controllers/MeasurementUnitsController.ts';
import { MeasurementUnit } from '../../models/measurementUnits/measurementUnit.ts';
import { useAlert } from '../alertProvider.tsx';

type MeasurementUnitContextType = {
    isLoaded?: boolean;
    measurementUnit: MeasurementUnit;
    insertMeasurementUnit: (entity: MeasurementUnit) => void;
    updateMeasurementUnit: (entity: MeasurementUnit) => void;
};

const MeasurementUnitContext = createContext<MeasurementUnitContextType>({} as MeasurementUnitContextType);

export const MeasurementUnitContextProvider = ({ children, id }: { children: any, id?: any }) => {
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [measurementUnit, setMeasurementUnit] = useState<MeasurementUnit>({} as MeasurementUnit);
    const { showAlert } = useAlert();
    const navigate = useNavigate();
    useEffect(() => {
        const getMeasurementUnitByID = async () => {
            if (id == "create") { setIsLoaded(true); return; }
            try {
                const result = await MeasurementUnitsController.getByID(id);
                if (result.notificationStatus == StatusCode.success)
                    setMeasurementUnit(result);
                else showAlert(result.notificationStatus, result.notificationMessage);
            } catch (error) {
                console.error('Error fetching measurementUnit:', error);
            } finally {
                setIsLoaded(true);
            }
        }
        getMeasurementUnitByID();
    }, [id]);

    const insertMeasurementUnit = async (entity: MeasurementUnit) => {
        try {
            const result = await MeasurementUnitsController.post(entity);
            if (result.notificationStatus == StatusCode.success)
                navigate(-1);
            else
                showAlert(result.notificationStatus, result.notificationMessage);
        } catch (error) {
            console.error('Error inserting measurementUnit:', error);
        }
    }

    const updateMeasurementUnit = async (entity: MeasurementUnit) => {
        try {
            const result = await MeasurementUnitsController.put(entity);
            if (result.notificationStatus == StatusCode.success)
                navigate(-1);
            else
                showAlert(result.notificationStatus, result.notificationMessage);
        } catch (error) {
            console.error('Error updating measurementUnit:', error);
        }
    }

    const context: MeasurementUnitContextType = {
        isLoaded,
        measurementUnit,
        insertMeasurementUnit,
        updateMeasurementUnit
    }

    return (
        <MeasurementUnitContext.Provider value={context}>
            {children}
        </MeasurementUnitContext.Provider>
    )
}

export const useMeasurementUnitContext = () => useContext(MeasurementUnitContext)
